"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionSummaryToJSON = exports.SessionSummaryFromJSONTyped = exports.SessionSummaryFromJSON = void 0;
function SessionSummaryFromJSON(json) {
    return SessionSummaryFromJSONTyped(json, false);
}
exports.SessionSummaryFromJSON = SessionSummaryFromJSON;
function SessionSummaryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'roles': json['roles'],
        'active': json['active'],
    };
}
exports.SessionSummaryFromJSONTyped = SessionSummaryFromJSONTyped;
function SessionSummaryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'roles': value.roles,
        'active': value.active,
    };
}
exports.SessionSummaryToJSON = SessionSummaryToJSON;
//# sourceMappingURL=SessionSummary.js.map